<template>

	<router-link v-if="to" :to="to" :class="classes" active-class="bg-accent text-accent-content hover:bg-accent hover:cursor-pointer"><slot /></router-link>
	<a v-if="!to && href" :href="href" :class="classes" @click="clickCallback"><slot /></a>

</template>

<script lang="ts">
export default {
    name: "SideBarMenuLink",
    props: {
        active: {
            type: Boolean,
            default: false
        },
        href: {
            type: String
        },
        to: {
        },
		clickCallback: {
			type: Function,
			default: null,
		}
    },

	data() {
			return {
				classes: [
					'group flex items-center text-base-content md:text-sm px-2 py-2 font-medium rounded-md',
					this.active ?
							'bg-accent text-accent-content'
							: 'hover:bg-base'
				]
			}
	}
}
</script>
